import { useEffect, useState } from "react";

// Parent-window edit-mode signaling. The Claude Design tool (and similar
// embed parents) opt into TweaksPanel visibility via postMessage:
//   { type: "__activate_edit_mode" }   → enable
//   { type: "__deactivate_edit_mode" } → disable
// We acknowledge availability up-front via __edit_mode_available so the
// parent knows we honor the protocol.
export function useEditModePostMessage(): boolean {
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    const handler = (e: MessageEvent) => {
      const data = e.data;
      if (!data || typeof data !== "object") return;
      if (data.type === "__activate_edit_mode") setEditMode(true);
      if (data.type === "__deactivate_edit_mode") setEditMode(false);
    };
    window.addEventListener("message", handler);
    try {
      window.parent.postMessage({ type: "__edit_mode_available" }, "*");
    } catch {
      // Cross-origin parent or no parent — fine, just don't acknowledge.
    }
    return () => window.removeEventListener("message", handler);
  }, []);

  return editMode;
}
